import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HOMEPAGE_FAQS } from "@/lib/faqData";

const HOME_FAQ_QUESTIONS = [
  "How does pricing work?",
  "Do you accept FSA or HSA?",
  "Where are prescriptions fulfilled?",
  "Does my plan renew automatically?",
  "How can I pause or cancel my treatment?",
];

export const HOME_FAQS = HOME_FAQ_QUESTIONS.map((q) => HOMEPAGE_FAQS.find((f) => f.q === q));
const faqs = HOME_FAQS;

export default function HomeFAQ() {
  return (
    <section data-testid="home-faq" className="bg-white border-t border-[#E8E5DF] -mb-20">
      <div className="max-w-[720px] mx-auto px-4 sm:px-6 pt-8 md:pt-10 pb-10 md:pb-12">
      <h2 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-[#2C2B29] text-center">
        Questions? We&apos;ve got answers.
      </h2>
      <Accordion type="single" collapsible className="mt-4 md:mt-5 border-t border-[#E8E5DF]" data-testid="home-faq-accordion">
        {faqs.map((f, i) => (
          <AccordionItem
            key={f.q}
            value={`item-${i}`}
            data-testid={`home-faq-item-${i}`}
            className="border-b border-[#E8E5DF]"
          >
            <AccordionTrigger className="text-left font-display text-base font-semibold text-[#2C2B29] hover:no-underline py-1.5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[#5E5C58] leading-relaxed pb-3 text-sm md:text-base">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      <div className="mt-2 text-center">
        <Link
          to="/faq"
          data-testid="home-faq-see-all"
          className="inline-flex items-center gap-1.5 min-h-[44px] text-sm md:text-base font-semibold text-[#2C2B29] underline decoration-[#C96A4E] decoration-2 underline-offset-4 hover:text-[#C96A4E] transition-colors"
        >
          See all FAQs
          <ArrowRight size={16} />
        </Link>
      </div>
      </div>
    </section>
  );
}
